var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.disabled},on:{"click":_vm.cacheStaticSearches}},[_c('i',{staticClass:"mdi mdi-reload"}),_vm._v("\n  Selecties opnieuw laden\n")])}
var staticRenderFns = []

export { render, staticRenderFns }